import MenuBar from "./Component/MenuBar";
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
import Footer from "./Component/Footer";
const FoodDonation = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner Section */}
            <PageBanner title="Food Donation" current="Donate Grocery" />


            {/* Contact Section */}
            <section className="contact-section contact-page">
                <div
                    className="icon-three paroller"
                    data-paroller-factor="-0.10"
                    data-paroller-factor-lg="-0.15"
                    data-paroller-factor-sm="0.10"
                    data-paroller-type="foreground"
                    data-paroller-direction="horizontal"
                >
                    <span className="flaticon-dove"></span>
                </div>

                <div className="auto-container">
                    <div className="sec-title centered">
                        <div className="upper-icon"></div>
                        <h2>Get In Touch!</h2>
                        <div className="text">
                            Would you like to make a food donation for our temple kitchen?
                            Please click below and send us a message with the items and
                            quantities you wish to donate (Ghee (5 tubs), Besan flour (50 lbs), Suji (40 lbs), Oil (5 cans of 25L), Yellow moong dal (50 lbs), and Sugar (50 lbs)).
                        </div>
                    </div>

                    <div className="row clearfix">
                        {/* Button Column */}
                        <div className="form-column col-xl-7 col-lg-12 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="default-form contact-form">
                                    <div className="col-md-12 col-sm-12">
                                        <div className="inner-button">
                                            <a
                                                href="https://ykportal.yugalkunj.org/home/contact"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="theme-btn btn-style-one"
                                                style={{
                                                    width: "300px",
                                                    textAlign: "center",
                                                    color: "#fff",
                                                }}
                                            >
                                                <span className="btn-title">Contact Us to Donate</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Image Column */}
                        <div className="image-column col-xl-5 col-lg-12 col-md-12 col-sm-12">
                            <div className="inner">
                                <div
                                    className="icon-1 paroller"
                                    data-paroller-factor="-0.30"
                                    data-paroller-factor-lg="-0.20"
                                    data-paroller-factor-sm="-0.20"
                                    data-paroller-type="foreground"
                                    data-paroller-direction="vertical"
                                ></div>
                                <div
                                    className="icon-2 paroller"
                                    data-paroller-factor="0.30"
                                    data-paroller-factor-lg="0.20"
                                    data-paroller-factor-sm="0.10"
                                    data-paroller-type="foreground"
                                    data-paroller-direction="vertical"
                                ></div>
                                <figure className="image">
                                    <img
                                        src="https://stssevastorage.blob.core.windows.net/ykwebsite/resource/featured-image-3.jpg"
                                        alt="Food donation"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>

                    {/* existing info blocks stay the same */}
                    {/* ... keep your info-container and map section as you already have ... */}
                </div>
            </section>

            {/* Map & Footer stay as in your original code */}
            {/* Map Section */}
            <section className="map-section">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="map">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6616.706205168105!2d-84.12566100000001!3d33.983463!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a2e90fd1f963%3A0x1ec46d89ce53332c!2s2769%20Duluth%20Hwy%2C%20Duluth%2C%20GA%2030096!5e0!3m2!1sen!2sus!4v1589379025209!5m2!1sen!2sus"
                                    width="100%"
                                    height="250"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Yugal Kunj Location"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default FoodDonation;
